module.exports = __webpack_public_path__ + "static/media/vimeo-v.4a02029f.svg";